<template>
  <div class="rt-card"><slot /></div>
</template>

<script>
export default {
  name: 'RtCard'
};
</script>

<style lang="less">
.rt-card {
  background: #fff;
  margin-top: 10px;
  margin-left: 10px;
  margin-bottom: 10px;
  & > .el-tabs > .el-tabs__header {
    // margin:0;
    margin: 0 25px 0px;
  }
  & > .el-tabs {
    & .rt-section {
      margin: 0;
      padding: 0;
    }
  }
  & .el-tabs__nav {
    // width: 100%;
    // display: flex;
    // justify-content: space-between;
    // padding: 0 30px;
    // box-sizing: border-box;
  }
  & .el-tabs__active-bar {
    height: 3px;
    background-color: #0099ff;
  }
  & .el-tabs__item.is-active {
    color: #0099ff;
  }
  & .el-tabs__item {
    height: 63px;
    line-height: 63px;
    color: #839dbe;
  }
  & .el-tabs__nav-wrap::after {
    height: 1px;
  }
  & .el-tabs__content {
    & .sub-grid {
      padding: 0px 0 5px 0;
    }
    & .sub-grid::before {
      height: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// rtCard.vue?46df9e52